module.exports = __webpack_public_path__ + "static/img/native.fabdd8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/native.png
// module id = FGDW
// module chunks = 1 3